import { createSelector } from 'reselect'
import { State } from '../../reducers/reducerType'
import username from '../../../lib/username'
import { LocalParticipant, RemoteParticipant } from 'twilio-video'

/**
 * Returns an array of the currently active dialed-in users
 * @param state The Redux state
 */

const getOtherParticipants = (state: State): Map<string, RemoteParticipant> => state.room.room ? state.room.room.participants : new Map()
const localParticipant = (state: State): [LocalParticipant] | [] => state.room.room ? [state.room.room.localParticipant] : []

export default createSelector(
  [getOtherParticipants, localParticipant],
  (otherParticipants, localParticipant): string[] => {
    
    return [...localParticipant, ...Array.from(otherParticipants.values())]
    .map(({identity}) => identity)
    .filter(participant => username.isDialIn(participant))
  }
  
)
